module.exports = __webpack_public_path__ + "static/media/key.c4ae9258.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallWindow/key.svg
// module id = 1758
// module chunks = 0